import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyRupees: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCurrencyRupees"><Path d="M20 4H15.4707C16.2104 4.82621 16.7234 5.85821 16.915 7H20V9H16.915C16.4388 11.8376 13.9729 14 11 14H7.33301L16.4004 20.7998L15.2002 22.4004L4 14V12H11C12.8638 12 14.43 10.7252 14.874 9H4V7H14.874C14.43 5.27477 12.8638 4 11 4H4V2H20V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCurrencyRupees;
